import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './cart/cart';
import './cart/cart-utils';
import './cart/cart-top-offset';
import './sliders/product-slider';
import './sliders/products-slider';
import './product/ajax-actions';
import './product/quantity';
import './product/handle-options';
import './product/change-color-name';
import './product/change-image';
import './product/change-slide';
import './product/change-price';
import './product/handle-notify-popup';
import './product/product-bar-add-to-cart';
import './product/handle-product-bar';
import './product/handle-options-redirect';
import './polyfills/object-fit';
import './header/header-fixed';
import './accordion/accordion';
import './modal/handle-modal';
import './modal/handle-image-modal';
import './form/klaviyo-back-in-stock';
import './form/contact-form-accept-marketing';
import './form/contact-form-create-customer';
import './popup/handle-cookie-popup';
import './popup/handle-subscribe-popup';
import './customer/handle-accentuate-customer-details-form';
import './menu/handle-menu-dropdown';
import './menu/handle-mobile-menu';
import './search/handle-search-panel';
import './collapse/handle-collapse';

const $win = $(window);
const $doc = $(document);
